import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectState = (state) => state.get('registerPage') || initialState;

export const selectSubmitting = createSelector(selectState, (state) => state.get('submitting'));

export const selectSubmitDone = createSelector(selectState, (state) => state.get('submitDone'));

export const selectEmailVerificationRequested = createSelector(selectState, (state) =>
  state.get('emailVerificationRequested')
);

export const selectErrorCode = createSelector(selectState, (state) => state.get('errorCode'));

export const selectErrorMsg = createSelector(selectState, (state) => state.get('errorMsg'));

export const selectDuplicateNonprofitId = createSelector(selectState, (state) =>
  state.get('duplicateNonprofitId')
);

export const selectDuplicateNonprofitName = createSelector(selectState, (state) =>
  state.get('duplicateNonprofitName')
);
